/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Howto_3Inputs */

const vi_einvoice_credential_howto_3 = /** @type {(inputs: Einvoice_Credential_Howto_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bước 3: kiểm tra lại tài khoản MISA vừa kết nối. Bạn có thể kiểm tra kết nối hoặc gỡ tài khoản tại đây.`)
};

/**

* @param {Einvoice_Credential_Howto_3Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_howto_3 = /** @type {((inputs?: Einvoice_Credential_Howto_3Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Howto_3Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_howto_3(inputs)
});